import React, { useState, useEffect, useCallback } from "react";
import StockBoard from "src/components/home/StockBoard";
import { getPopular } from "src/api/MessageApi";
import { ListParam, defaultListParam } from "src/types/api/listParam";

interface StockContainerProps {
  rowPerPage: number;
}

const StockContainer: React.FC<StockContainerProps> = ({ rowPerPage }) => {
  const [stockcontents, setStockContents] = useState([]);
  const [curPage, setCurPage] = useState(null);
  const [isMore, setIsMore] = useState(true);
  const [date, setDate] = useState('')

  const fetchData = useCallback(async (params: ListParam) => {
    try{
      let response;
      response = await getPopular(params);
  
      const newData = response?.data?.list || [];
      const date = response?.data?.param.yyyymmdd || [];

      if ( newData.length < rowPerPage ){
        setIsMore(false)
      } else {
        setIsMore(true)
      }
      if (params.curPage === 1) {
        setStockContents(newData);
        setDate(date)
      } else {
        setStockContents((prevData) => [...prevData, ...newData]); 
      }
    } catch (error) {
        console.error("API 호출 실패:", error);
        if (params.curPage === 1) setStockContents([]);
    }
  },[rowPerPage]);
  
  useEffect(() => { 
      setCurPage(null);
      const defaultParams = defaultListParam();
      defaultParams.rowPerPage = rowPerPage
      fetchData(defaultParams);
  }, [rowPerPage, fetchData]);

  const handleLoadMore = async () => {
    try {
      const defaultParams = defaultListParam();
      const newPage = curPage === null ? 2 : curPage + 1;
      defaultParams.curPage = newPage
      defaultParams.rowPerPage = rowPerPage
      defaultParams.yyyymmdd = date
      await fetchData(defaultParams);
      setCurPage(newPage);
    } catch (error) {
        console.error("추가 데이터 로드 실패:", error);
    }
  };


  return (
      <StockBoard contents={stockcontents} isMore={isMore} handleLoadMore={handleLoadMore} />
  );
};

export default StockContainer;
